import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from '~client/reducers';

const middlewares = [thunk];

let enhancers = applyMiddleware(...middlewares);

if (process.env.NODE_ENV !== 'production') {
  const newEnhancers = applyMiddleware(...middlewares);
  /* eslint-disable no-underscore-dangle */
  enhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(newEnhancers)
    : newEnhancers;
  /* eslint-enable */
}

const store = createStore(reducer, enhancers);

export default store;
